var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.208C6.05623 16.208 0 22.2643 0 29.708V30.2175H27V29.708C27 22.2609 20.9438 16.208 13.5 16.208ZM1.03227 29.1953C1.3004 22.5525 6.79022 17.2303 13.5 17.2303C20.2098 17.2303 25.6996 22.5525 25.9677 29.1953H1.03227ZM13.5 13.5603C17.237 13.5603 20.2802 10.5205 20.2802 6.78016C20.2802 3.0432 17.2403 0 13.5 0C9.76303 0 6.71984 3.03985 6.71984 6.78016C6.71984 10.5171 9.76303 13.5603 13.5 13.5603ZM13.5 1.02222C16.6739 1.02222 19.2579 3.60626 19.2579 6.78016C19.2579 9.95407 16.6739 12.5381 13.5 12.5381C10.3261 12.5381 7.74206 9.95407 7.74206 6.78016C7.74206 3.60626 10.3261 1.02222 13.5 1.02222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1790d00bd105e86bccc601a857a2232b.svg";
export { ForwardRef as ReactComponent };